// Relative Work end ranges a Work view stores instead of dates. The page
// resolves them against the viewer's today on every load. `no_due_date` has
// no range: it matches work without a Work end date.
export const WORK_DELIVERY_DATE_PRESETS = [
    "before_today",
    "next_14_days",
    "this_month",
    "no_due_date",
] as const;

export type WorkDeliveryDatePreset =
    (typeof WORK_DELIVERY_DATE_PRESETS)[number];
